import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import Layout from './views/Layout';
import './App.css'
import { Provider } from 'react-redux'
import store from './redux/store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


// Create a client
const queryClient = new QueryClient()

function App() {

  
  return (
    // Provide the client to your App
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <Layout />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          className={"!z-[1000000000000]"}
        />
      </Provider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  );
}

export default App;
